import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./navbar";
import SecondaryNavbar from "./secondaryNavbar";
const MainNavbar = ({}: {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [navbarHide, setNavbarHide] = useState(false);
  const newPathName = location.pathname.split("/")[1];

  console.log(newPathName, location);

  // useEffect(() => {
  //   if (pathname === "/collection-all") {
  //     setNavbarHide(true);
  //   }
  // }, [pathname]);

  console.log(newPathName, newPathName === "collection");

  return (
    <div>
      {location?.pathname === "/" ||
      location?.pathname == "/collection" ||
      newPathName === "collection" ||
      location?.pathname === "/admin-dashboard" ||
      location?.pathname === "/admin-dashboard/reports-list" ||
      location?.pathname === "/admin-dashboard/nfts" ||
      location?.pathname === "/admin-login" ||
      location?.pathname === "/admin-dashboard/rewards" ? (
        ""
      ) : (
        <Navbar />
      )}
    </div>
  );
};

export default MainNavbar;
